import { styled } from '@mui/material'
import { BETWEEN_CARDS_SPACING } from 'redesign/shared/constants'

export const ListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  > :last-child {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }
`

export const ListContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'gap',
})<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, gap }) => theme.spacing(gap ?? BETWEEN_CARDS_SPACING)};
`

export const EmptyContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
`
